
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g3LxX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $753deba3fe656290$var$initialState = {
    isInViewMode: true,
    isInAutoFocusMode: true,
    selectedExtensionLocalId: null,
    selectedToEditCardId: null,
    selectedToRemoveCardId: null
};
// Actions for managing the Custom Site Extensions state that is shared between the extension and the config panel
const $753deba3fe656290$var$actions = {
    setIsInViewMode: (isInViewMode)=>({ setState: setState })=>{
            setState({
                isInViewMode: isInViewMode
            });
        },
    setIsInAutoFocusMode: (isInAutoFocusMode)=>({ setState: setState })=>{
            setState({
                isInAutoFocusMode: isInAutoFocusMode
            });
        },
    setSelectedExtensionLocalId: (extensionLocalId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedExtensionLocalId: extensionLocalId
            });
        },
    setSelectedToEditCardId: (cardId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedToEditCardId: cardId
            });
        },
    setSelectedToRemoveCardId: (cardId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedToRemoveCardId: cardId
            });
        }
};
const $753deba3fe656290$var$ExtensionsStateStore = (0, $1P1Tu.createStore)({
    initialState: $753deba3fe656290$var$initialState,
    actions: $753deba3fe656290$var$actions,
    name: 'ExtensionsStateStore'
});
const $753deba3fe656290$export$732cb2f7b629a11e = (0, $9zUhf.createHook)($753deba3fe656290$var$ExtensionsStateStore);
const $753deba3fe656290$export$d50cb813b9099554 = (0, $9zUhf.createActionsHook)($753deba3fe656290$var$ExtensionsStateStore);
module.exports["useExtensionsState"] = $753deba3fe656290$export$732cb2f7b629a11e;
module.exports["useExtensionsActions"] = $753deba3fe656290$export$d50cb813b9099554;

});

parcelRegister("lhvsH", function(module, exports) {

var $1u5CA = parcelRequire("1u5CA");

const $c7b070100499a556$export$47962e37d9fd03c7 = (0, $1u5CA.knownBackgroundColors)[10];
module.exports["DEFAULT_GRAY_COLOR"] = $c7b070100499a556$export$47962e37d9fd03c7;

});

parcelRegister("1VNax", function(module, exports) {
const $c0bf087c1d0f2640$var$validateItemsUrls = (items)=>{
    items.forEach((item)=>{
        if (!!item?.link && !item?.link.startsWith('http')) item.link = '';
    });
};
const $c0bf087c1d0f2640$export$3831ccf0db7ad748 = (items)=>{
    if (!items || items?.length === 0) return null;
    else if (Array.isArray(items)) {
        $c0bf087c1d0f2640$var$validateItemsUrls(items);
        return items;
    }
};
module.exports["checkItems"] = $c0bf087c1d0f2640$export$3831ccf0db7ad748;

});

parcelRegister("5un3P", function(module, exports) {

var $4cOi8 = parcelRequire("4cOi8");

const $a247ba2e22f9ecac$export$12c9c8946ce83b13 = 3;
var $a247ba2e22f9ecac$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $a247ba2e22f9ecac$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["CENTER"] = "center";
    Alignment["RIGHT"] = "right";
    return Alignment;
}({});
var $a247ba2e22f9ecac$export$a1ccd8e6c4b447b2 = /*#__PURE__*/ function(ImagePosition) {
    ImagePosition["TOP"] = "top";
    ImagePosition["MIDDLE"] = "middle";
    ImagePosition["BOTTOM"] = "bottom";
    return ImagePosition;
}({});
var $a247ba2e22f9ecac$export$9eefe1d63a5bbb7e = /*#__PURE__*/ function(CardsLayout) {
    CardsLayout["FIXED_IMAGE_HEIGHT"] = "fixed-image-height";
    CardsLayout["FLEXIBLE_IMAGE_HEIGHT"] = "flexible-image-height";
    return CardsLayout;
}({});
module.exports["DEFAULT_DYNAMIC_CARDS_COUNT"] = $a247ba2e22f9ecac$export$12c9c8946ce83b13;
module.exports["Orientation"] = $a247ba2e22f9ecac$export$df54d73aa0ec5e82;
module.exports["Alignment"] = $a247ba2e22f9ecac$export$9d7927214ed7d2cf;
module.exports["ImagePosition"] = $a247ba2e22f9ecac$export$a1ccd8e6c4b447b2;
module.exports["CardsLayout"] = $a247ba2e22f9ecac$export$9eefe1d63a5bbb7e;

});

parcelRegister("cKAxI", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $cUcZ5 = parcelRequire("cUcZ5");


var $bre0g = parcelRequire("bre0g");


var $dh538 = parcelRequire("dh538");


var $fwDOR = parcelRequire("fwDOR");


var $lhvsH = parcelRequire("lhvsH");


var $4cOi8 = parcelRequire("4cOi8");

var $fcAaV = parcelRequire("fcAaV");


var $kcoxM = parcelRequire("kcoxM");


var $5un3P = parcelRequire("5un3P");


var $51FJF = parcelRequire("51FJF");


const $e60576104e03cc2c$var$CardsExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "JDp8H",
    name: "CardsExtension",
    loader: async ()=>(await (parcelRequire("7jB45"))).CardsExtension,
    loading: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
            name: "cards-extension-loader"
        })
});
const $e60576104e03cc2c$export$b7316deff43c35f7 = (imageSrc, imageAltText)=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        link: '',
        isLinkUserEdited: false,
        title: '',
        isTitleUserEdited: false,
        description: '',
        isDescriptionUserEdited: false,
        imageSrc: imageSrc,
        imagePosition: (0, $5un3P.ImagePosition).MIDDLE,
        imageAltText: imageAltText
    });
let $e60576104e03cc2c$var$cards = null;
const $e60576104e03cc2c$export$adc082ec96ce9cca = ()=>{
    if ($e60576104e03cc2c$var$cards) return $e60576104e03cc2c$var$cards;
    return $e60576104e03cc2c$var$cards = (0, $kcoxM.CARDS_IMAGES_V5).map(({ src: src, alt: alt })=>$e60576104e03cc2c$export$b7316deff43c35f7(src, alt));
};
const $e60576104e03cc2c$export$611063def302f5f2 = ({ extensionTitle: extensionTitle, isDynamicCardsAIDescriptionsEnabled: isDynamicCardsAIDescriptionsEnabled, defaultParameters: defaultParameters })=>{
    const parameters = {
        size: (0, $4cOi8.Height).MEDIUM,
        cards: $e60576104e03cc2c$export$adc082ec96ce9cca(),
        isAvatarShown: false,
        isPublishDateShown: false,
        extensionTitle: extensionTitle,
        version: (0, $kcoxM.CARDS_EXTENSION_VERSION_5),
        renderVariant: (0, $4cOi8.RenderVariant).MANUAL,
        isSegmentationShown: false,
        orientation: (0, $5un3P.Orientation).STACKED,
        alignment: (0, $5un3P.Alignment).CENTER,
        isAutoscrollEnabled: false,
        backgroundColor: defaultParameters?.backgroundColor ?? "var(--ds-surface-overlay, #FFFFFF)",
        textColor: defaultParameters?.textColor ?? "var(--ds-text, #292A2E)",
        cornerStyle: (0, $4cOi8.CornerStyle).ROUNDED,
        isSocialStatsShown: false,
        isIconShown: true,
        layout: (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT,
        isPaddingEnabled: true,
        isLabelShown: true,
        borderColor: (0, $lhvsH.DEFAULT_GRAY_COLOR)
    };
    if (isDynamicCardsAIDescriptionsEnabled) parameters.isDescriptionShown = true;
    return parameters;
};

const $e60576104e03cc2c$export$c0798477a3103ad2 = ({ contentId: contentId, propsProvider: propsProvider, mode: mode, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl, setUpsellModalSource: setUpsellModalSource })=>{
        const parameters = $e60576104e03cc2c$export$611063def302f5f2({
            extensionTitle: intl.formatMessage((0, $51FJF.messages).linkCardsMacroTitle),
            isDynamicCardsAIDescriptionsEnabled: (0, $dh538.fg)('company_hub_dynamic_cards_ai_descriptions'),
            defaultParameters: defaultParameters
        });
        return new (0, $bre0g.default)([
            (0, $fcAaV.getExtensionManifest)({
                title: intl.formatMessage((0, $51FJF.messages).linkCardsMacroTitle),
                type: (0, $kcoxM.CARDS_EXTENSION_TYPE),
                key: (0, $kcoxM.CARDS_EXTENSION_KEY),
                description: intl.formatMessage((0, $51FJF.messages).linkCardsMacroDescription),
                icons: {
                    '48': ()=>(parcelRequire("9AEfc")).then((mod)=>mod.CardsExtensionIcon)
                },
                parameters: parameters,
                update: async ()=>{
                    const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                    const selectedLocalId = selectedNode?.attrs?.localId;
                    if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                },
                render: async ()=>({ node: node })=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)($e60576104e03cc2c$var$CardsExtension, {
                            extensionNode: node,
                            contentId: contentId,
                            propsProvider: propsProvider,
                            mode: mode
                        });
                    },
                quickInsertAction: async ()=>Promise.resolve({
                        type: 'extension',
                        key: (0, $kcoxM.CARDS_EXTENSION_KEY),
                        attrs: {
                            extensionType: (0, $kcoxM.CARDS_EXTENSION_TYPE),
                            extensionKey: (0, $kcoxM.CARDS_EXTENSION_KEY),
                            layout: 'default',
                            parameters: parameters
                        }
                    }),
                source: 'premiumCardsInsert',
                setUpsellModalSource: setUpsellModalSource
            })
        ]);
    };
};
module.exports["getDefaultCards"] = $e60576104e03cc2c$export$adc082ec96ce9cca;
module.exports["getCardsExtensionParameters"] = $e60576104e03cc2c$export$611063def302f5f2;
module.exports["cardsExtensionProvider"] = $e60576104e03cc2c$export$c0798477a3103ad2;

});

parcelRegister("51FJF", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $d14ef5a1094a027d$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    linkCardsMacroTitle: {
        id: "company-hub.cards-extension.manifest.macro-title",
        defaultMessage: "Cards"
    },
    linkCardsMacroDescription: {
        id: "company-hub.cards-extension.manifest.macro-description",
        defaultMessage: "Display links as cards"
    }
});
module.exports["messages"] = $d14ef5a1094a027d$export$defe85febe8b728c;

});

parcelRegister("7jB45", function(module, exports) {

let $55370f1520608c73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $55370f1520608c73$var$load("e6ams"),
    $55370f1520608c73$var$load("iVgrO"),
    $55370f1520608c73$var$load("8KWDC"),
    $55370f1520608c73$var$load("bTmOC"),
    $55370f1520608c73$var$load("2euij"),
    $55370f1520608c73$var$load("kZMnh"),
    $55370f1520608c73$var$load("855o0"),
    $55370f1520608c73$var$load("8MfZE"),
    $55370f1520608c73$var$load("6wr18"),
    $55370f1520608c73$var$load("kjZZD"),
    $55370f1520608c73$var$load("ffEVr"),
    $55370f1520608c73$var$load("dTsOE"),
    $55370f1520608c73$var$load("3gJkK")
]).then(()=>parcelRequire('gnpMO'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("9AEfc", function(module, exports) {

let $6fb6b18034134dd2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6fb6b18034134dd2$var$load("gKYwM").then(()=>parcelRequire('4LKV2'));

});

parcelRegister("9Uxg8", function(module, exports) {

var $4cOi8 = parcelRequire("4cOi8");

var $4c5172dc3da882ee$export$f8af16d8231e3b4e = /*#__PURE__*/ function(NavigationStyle) {
    NavigationStyle["PROGRESS_CIRCLES"] = "progress-circles";
    NavigationStyle["THUMBNAILS"] = "thumbnails";
    return NavigationStyle;
}({});
var $4c5172dc3da882ee$export$f34582f4a07dd8dd = /*#__PURE__*/ function(FrameSizes) {
    FrameSizes["NAVIGATION_THUMBNAIL"] = "navigationThumbnail";
    FrameSizes["NAVIGATION_THUMBNAIL_V2"] = "navigationThumbnailV2";
    return FrameSizes;
}({});
const $4c5172dc3da882ee$export$288376e91ac51845 = {
    ["navigationThumbnailV2"]: {
        minWidth: 200,
        maxWidth: 200,
        height: 40
    },
    ["navigationThumbnail"]: {
        minWidth: 244,
        maxWidth: 250,
        height: 72
    }
};
module.exports["NavigationStyle"] = $4c5172dc3da882ee$export$f8af16d8231e3b4e;
module.exports["FrameSizes"] = $4c5172dc3da882ee$export$f34582f4a07dd8dd;
module.exports["framesDimensions"] = $4c5172dc3da882ee$export$288376e91ac51845;

});

parcelRegister("g6QUH", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $bre0g = parcelRequire("bre0g");


var $fwDOR = parcelRequire("fwDOR");


var $4cOi8 = parcelRequire("4cOi8");

var $fcAaV = parcelRequire("fcAaV");


var $5Ac5G = parcelRequire("5Ac5G");


var $eIwIu = parcelRequire("eIwIu");


var $9XEGe = parcelRequire("9XEGe");


const $4059117d6b06825c$var$CarouselExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "g5PGT",
    name: "CarouselExtension",
    loader: async ()=>(await (parcelRequire("hI409"))).CarouselExtension,
    loading: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
            name: "carousel-extension-loader"
        })
});
const $4059117d6b06825c$var$carouselFrames = [
    {
        imageSrc: (0, $eIwIu.FRAME_V2_DEFAULT_IMAGE_SRC),
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_LEFT
    },
    {
        imageSrc: (0, $eIwIu.FRAME_V2_DEFAULT_IMAGE_SRC),
        layout: (0, $4cOi8.CommonLayout).FRAME_ABOVE_IMAGE
    },
    {
        imageSrc: (0, $eIwIu.FRAME_V2_DEFAULT_IMAGE_SRC),
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT
    }
];
const $4059117d6b06825c$var$getV2Frames = ({ intl: intl, defaultParameters: defaultParameters })=>{
    return $4059117d6b06825c$var$carouselFrames.map(({ imageSrc: imageSrc, layout: layout })=>(0, $eIwIu.createNewFrameWithDefaultParameters)({
            intl: intl,
            defaultParameters: defaultParameters,
            defaultField: {
                imageSrc: imageSrc,
                layout: layout
            }
        }));
};
const $4059117d6b06825c$export$3339a462074fecc3 = ({ extensionTitle: extensionTitle, intl: intl, defaultParameters: defaultParameters })=>({
        cards: $4059117d6b06825c$var$getV2Frames({
            intl: intl,
            defaultParameters: defaultParameters
        }),
        extensionTitle: extensionTitle,
        version: (0, $5Ac5G.CAROUSEL_VERSION_2),
        ...(0, $eIwIu.carouselNewParametersV2)
    });

const $4059117d6b06825c$export$e807a589fe0f4d24 = ({ contentId: contentId, propsProvider: propsProvider, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, intl: intl, openConfigPanel: openConfigPanel, setUpsellModalSource: setUpsellModalSource })=>{
        const parameters = $4059117d6b06825c$export$3339a462074fecc3({
            extensionTitle: intl.formatMessage((0, $9XEGe.messages).carouselMacroTitle),
            intl: intl,
            defaultParameters: defaultParameters
        });
        return new (0, $bre0g.default)([
            (0, $fcAaV.getExtensionManifest)({
                title: intl.formatMessage((0, $9XEGe.messages).carouselMacroTitleUpdated),
                type: (0, $5Ac5G.carouselExtensionType),
                key: (0, $5Ac5G.carouselExtensionKey),
                description: intl.formatMessage((0, $9XEGe.messages).carouselMacroDescription),
                icons: {
                    '48': ()=>(parcelRequire("a5YHa")).then((mod)=>mod.CarouselExtensionIcon)
                },
                parameters: parameters,
                update: async ()=>{
                    const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                    const selectedLocalId = selectedNode?.attrs?.localId;
                    if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                },
                render: async ()=>({ node: node })=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)($4059117d6b06825c$var$CarouselExtension, {
                            propsProvider: propsProvider,
                            extensionNode: node,
                            contentId: contentId
                        });
                    },
                setUpsellModalSource: setUpsellModalSource,
                source: 'premiumCarouselInsert'
            })
        ]);
    };
};
module.exports["carouselParameters"] = $4059117d6b06825c$export$3339a462074fecc3;
module.exports["carouselExtensionProvider"] = $4059117d6b06825c$export$e807a589fe0f4d24;

});

parcelRegister("eIwIu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qzNs = parcelRequire("5qzNs");


var $8C5kA = parcelRequire("8C5kA");


var $cUcZ5 = parcelRequire("cUcZ5");


var $1VNax = parcelRequire("1VNax");

var $7q60U = parcelRequire("7q60U");

var $g3LxX = parcelRequire("g3LxX");

var $fOKpq = parcelRequire("fOKpq");


var $5Ac5G = parcelRequire("5Ac5G");


var $4cOi8 = parcelRequire("4cOi8");

var $9Uxg8 = parcelRequire("9Uxg8");


var $1JVKE = parcelRequire("1JVKE");

const $2417a3de58eaf173$export$3882df2b635374e2 = {
    cornerStyle: (0, $4cOi8.CornerStyle).ROUNDED,
    isAutoplayEnabled: false,
    navigationStyle: (0, $9Uxg8.NavigationStyle).THUMBNAILS
};
const $2417a3de58eaf173$export$b713c3bc8c446d60 = 'https://images.unsplash.com/photo-1488470015861-8bb1317353ef?auto=format&fit=crop&q=80&w=1080';
const $2417a3de58eaf173$export$27643bf44cc02178 = {
    [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    [(0, $4cOi8.ITEM_FIELDS).TEXT_COLOR]: "var(--ds-text, #292A2E)",
    [(0, $4cOi8.ITEM_FIELDS).LAYOUT]: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT,
    [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: $2417a3de58eaf173$export$b713c3bc8c446d60,
    [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: "Close-up of a vibrant green palm leaf\u2019s patterns.",
    buttonText: '',
    buttonStyle: (0, $4cOi8.ButtonStyle).DEFAULT
};
const $2417a3de58eaf173$export$4f94ab8184143ae6 = {
    imageSrc: 'https://images.unsplash.com/photo-1579547621706-1a9c79d5c9f1?auto=format&fit=crop&q=80&w=1080',
    imageAltText: 'purple and pink light illustration'
};
const $2417a3de58eaf173$export$5d30fc17e786110 = ({ intl: intl, defaultField: defaultField, randomLayout: randomLayout, defaultParameters: defaultParameters })=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        link: '',
        isLinkUserEdited: false,
        title: intl.formatMessage((0, $1JVKE.messages).placeholderTitle),
        isTitleUserEdited: false,
        description: intl.formatMessage((0, $1JVKE.messages).placeholderDescription),
        isDescriptionUserEdited: false,
        ...$2417a3de58eaf173$export$4f94ab8184143ae6,
        ...$2417a3de58eaf173$export$27643bf44cc02178,
        ...defaultParameters?.backgroundColor ? {
            [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: defaultParameters.backgroundColor
        } : {},
        ...defaultParameters?.textColor ? {
            [(0, $4cOi8.ITEM_FIELDS).TEXT_COLOR]: defaultParameters.textColor
        } : {},
        ...randomLayout && {
            [(0, $4cOi8.ITEM_FIELDS).LAYOUT]: randomLayout
        },
        ...defaultField
    });
const $2417a3de58eaf173$export$721510bd2cdb9b4f = (link, confluencePageId, isLinkUserEdited)=>{
    return {
        [(0, $4cOi8.ITEM_FIELDS).LINK]: link,
        [(0, $4cOi8.ITEM_FIELDS).CONFLUENCE_PAGE_ID]: confluencePageId || '',
        [(0, $4cOi8.ITEM_FIELDS).IS_LINK_USER_EDITED]: isLinkUserEdited || false
    };
};
const $2417a3de58eaf173$var$fetchLocalIdMacroParameters = ({ editorActions: editorActions, localId: localId })=>{
    var _params, _params1, _params2;
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    let params = localIdNode?.attrs?.parameters;
    if (params === undefined) return undefined;
    // Make a copy of the params object to avoid mutating the original object
    params = {
        ...params
    };
    // If the extension was created prior to removal of type field, remove it from object here
    // This update is/was not done in combination with a feature gate
    delete params['type'];
    params.version = (0, $5Ac5G.CAROUSEL_VERSION_2);
    const { cornerStyle: cornerStyle, isAutoplayEnabled: isAutoplayEnabled, navigationStyle: navigationStyle } = $2417a3de58eaf173$export$3882df2b635374e2;
    (_params = params).cornerStyle ?? (_params.cornerStyle = cornerStyle);
    (_params1 = params).isAutoplayEnabled ?? (_params1.isAutoplayEnabled = isAutoplayEnabled);
    (_params2 = params).navigationStyle ?? (_params2.navigationStyle = navigationStyle);
    /* construct frames array with intercepted params */ params.cards = params.cards?.map((frame)=>{
        return {
            ...$2417a3de58eaf173$export$27643bf44cc02178,
            // override BG color back to white for v1 carousels to maintain parity...
            [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-background-input, #FFFFFF)",
            // ... but let frame BG color (if already set, eg to default color) override again
            ...(0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(frame, [
                'imagePosition'
            ])
        };
    }) || params.cards;
    /* there were card fields added to carousel params that were nonfunctional.
   * reconstructing params to those with them omitted
   */ params = (0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(params, [
        'size',
        'isPublishDateShown',
        'isAvatarShown'
    ]);
    return params;
};
const $2417a3de58eaf173$var$updateFrameInList = (frames, cardId, updatedField)=>frames.map((frame)=>{
        if (frame.cardId === cardId) return {
            ...frame,
            ...updatedField
        };
        return frame;
    });
const $2417a3de58eaf173$export$3cf295eeccc933e1 = ({ localId: localId, editorActions: editorActions })=>{
    const { branding: branding } = (0, $fOKpq.useProductDependencies)();
    const defaultParameters = branding?.defaultParameters;
    const [carouselParameters, setCarouselParameters] = (0, $42omo.useState)($2417a3de58eaf173$var$fetchLocalIdMacroParameters({
        editorActions: editorActions,
        localId: localId
    }));
    const usedLayoutsRef = (0, $42omo.useRef)(new Set());
    const lastUsedLayoutRef = (0, $42omo.useRef)(null);
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = (0, $g3LxX.useExtensionsActions)();
    const { cards: frames } = carouselParameters ?? {};
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        const extensionNodeParams = $2417a3de58eaf173$var$fetchLocalIdMacroParameters({
            editorActions: editorActions,
            localId: localId
        });
        setCarouselParameters(extensionNodeParams);
    // we don't want to re-fetch the parameters when the default parameters change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorActions,
        localId
    ]);
    const getRandomLayout = (0, $42omo.useCallback)(()=>{
        const allLayouts = Object.values((0, $4cOi8.CommonLayout));
        if (usedLayoutsRef.current.size >= allLayouts.length - 1) usedLayoutsRef.current = new Set();
        const availableLayouts = allLayouts.filter((layout)=>!usedLayoutsRef.current.has(layout) && layout !== lastUsedLayoutRef.current);
        const randomIndex = Math.floor(Math.random() * availableLayouts.length);
        const randomLayout = availableLayouts[randomIndex];
        usedLayoutsRef.current.add(randomLayout);
        lastUsedLayoutRef.current = randomLayout;
        return randomLayout;
    }, []);
    const updateExtensionParams = (0, $42omo.useCallback)((newExtensionParameters)=>{
        setCarouselParameters((prevParams)=>{
            const updatedParams = {
                ...prevParams,
                ...newExtensionParameters
            };
            // Save params to ADF and state
            (0, $7q60U.updateNodeParameters)(editorActions, updatedParams);
            return updatedParams;
        });
    }, [
        editorActions
    ]);
    const addFrame = (0, $42omo.useCallback)(()=>{
        const newFrame = $2417a3de58eaf173$export$5d30fc17e786110({
            intl: intl,
            defaultParameters: defaultParameters,
            defaultField: undefined,
            randomLayout: getRandomLayout()
        });
        updateExtensionParams({
            cards: [
                ...(0, $1VNax.checkItems)(frames) || [],
                newFrame
            ]
        });
        setIsInAutoFocusMode(true);
        setSelectedToEditCardId(newFrame.cardId);
    // no need to re-run when default parameters change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        frames,
        updateExtensionParams,
        setSelectedToEditCardId,
        setIsInAutoFocusMode,
        intl,
        getRandomLayout
    ]);
    const removeFrame = (0, $42omo.useCallback)((cardId)=>updateExtensionParams({
            cards: frames.filter((frame)=>frame.cardId !== cardId)
        }), [
        frames,
        updateExtensionParams
    ]);
    const updateMainFormField = (0, $42omo.useCallback)((updatedFields)=>updateExtensionParams(updatedFields), [
        updateExtensionParams
    ]);
    const updateFrameFormField = (0, $42omo.useCallback)((cardId, updatedField)=>{
        const updatedFrames = $2417a3de58eaf173$var$updateFrameInList(frames, cardId, updatedField);
        updateExtensionParams({
            cards: updatedFrames
        });
    }, [
        frames,
        updateExtensionParams
    ]);
    const carouselActions = (0, $42omo.useMemo)(()=>({
            addFrame: addFrame,
            removeFrame: removeFrame,
            updateMainFormField: updateMainFormField,
            updateFrameFormField: updateFrameFormField
        }), [
        addFrame,
        removeFrame,
        updateMainFormField,
        updateFrameFormField
    ]);
    return {
        carouselParameters: carouselParameters,
        carouselActions: carouselActions
    };
};
module.exports["carouselNewParametersV2"] = $2417a3de58eaf173$export$3882df2b635374e2;
module.exports["FRAME_V2_DEFAULT_IMAGE_SRC"] = $2417a3de58eaf173$export$b713c3bc8c446d60;
module.exports["frameNewParametersV2"] = $2417a3de58eaf173$export$27643bf44cc02178;
module.exports["createNewFrameWithDefaultParameters"] = $2417a3de58eaf173$export$5d30fc17e786110;
module.exports["updateLinkAndConfluencePageId"] = $2417a3de58eaf173$export$721510bd2cdb9b4f;
module.exports["useCarouselExtensionParametersAndActions"] = $2417a3de58eaf173$export$3cf295eeccc933e1;

});

parcelRegister("1JVKE", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $512cd77b50dddf7a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    placeholderTitle: {
        id: "company-hub.carousel-extension.placeholder.title",
        defaultMessage: "Give your frame a title"
    },
    placeholderDescription: {
        id: "company-hub.carousel-extension.placeholder.description",
        defaultMessage: "Customize this frame to create a rotating carousel."
    }
});
module.exports["messages"] = $512cd77b50dddf7a$export$defe85febe8b728c;

});

parcelRegister("9XEGe", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $93d5a0345fe228e3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    carouselMacroTitle: {
        id: "company-hub.carousel-extension.manifest.macro-title",
        defaultMessage: "Carousel"
    },
    carouselMacroTitleUpdated: {
        id: "company-hub.carousel-extension.manifest.macro-title.updated",
        defaultMessage: "Carousel [Updated]"
    },
    carouselMacroDescription: {
        id: "company-hub.carousel-extension.manifest.macro-description",
        defaultMessage: "Create a rotating trio of dynamic frames."
    }
});
module.exports["messages"] = $93d5a0345fe228e3$export$defe85febe8b728c;

});

parcelRegister("hI409", function(module, exports) {

let $ce49a659678cda09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ce49a659678cda09$var$load("e6ams"),
    $ce49a659678cda09$var$load("iVgrO"),
    $ce49a659678cda09$var$load("g2A8O"),
    $ce49a659678cda09$var$load("bTmOC"),
    $ce49a659678cda09$var$load("6aY84"),
    $ce49a659678cda09$var$load("5CaYW"),
    $ce49a659678cda09$var$load("2euij"),
    $ce49a659678cda09$var$load("kZMnh"),
    $ce49a659678cda09$var$load("855o0"),
    $ce49a659678cda09$var$load("8MfZE"),
    $ce49a659678cda09$var$load("dek7I"),
    $ce49a659678cda09$var$load("9aQIt"),
    $ce49a659678cda09$var$load("XZauT"),
    $ce49a659678cda09$var$load("4S1SF"),
    $ce49a659678cda09$var$load("jiFtb"),
    $ce49a659678cda09$var$load("lm9Lt"),
    $ce49a659678cda09$var$load("9wPDc"),
    $ce49a659678cda09$var$load("1MWOL"),
    $ce49a659678cda09$var$load("6fQco"),
    $ce49a659678cda09$var$load("aOY32"),
    $ce49a659678cda09$var$load("7jSfd"),
    $ce49a659678cda09$var$load("4HZlX"),
    $ce49a659678cda09$var$load("kDqHr"),
    $ce49a659678cda09$var$load("dYtBN"),
    $ce49a659678cda09$var$load("kNV5Y"),
    $ce49a659678cda09$var$load("6wr18"),
    $ce49a659678cda09$var$load("kjZZD"),
    $ce49a659678cda09$var$load("ffEVr"),
    $ce49a659678cda09$var$load("dTsOE"),
    $ce49a659678cda09$var$load("bap37")
]).then(()=>parcelRequire('9deYz'));

});

parcelRegister("a5YHa", function(module, exports) {

let $759973d0146159f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $759973d0146159f3$var$load("8nWJU").then(()=>parcelRequire('ayHRb'));

});


//# sourceMappingURL=cards-extension.99c3e5ad.js.map
